
    import './styles.scoped.css';
    export default {
  "appbar": "awsui_appbar_hyvsj_159il_93",
  "appbar-nav": "awsui_appbar-nav_hyvsj_159il_117",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_159il_121",
  "appbar-tools": "awsui_appbar-tools_hyvsj_159il_125",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_159il_160",
  "has-notifications-content": "awsui_has-notifications-content_hyvsj_159il_167",
  "has-header": "awsui_has-header_hyvsj_159il_173",
  "has-dynamic-overlap-height": "awsui_has-dynamic-overlap-height_hyvsj_159il_173",
  "content-type-wizard": "awsui_content-type-wizard_hyvsj_159il_174",
  "content-type-cards": "awsui_content-type-cards_hyvsj_159il_177",
  "content-type-table": "awsui_content-type-table_hyvsj_159il_178",
  "background": "awsui_background_hyvsj_159il_213",
  "notifications-appbar-header": "awsui_notifications-appbar-header_hyvsj_159il_216",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_159il_228",
  "overlap": "awsui_overlap_hyvsj_159il_234",
  "content": "awsui_content_hyvsj_159il_174",
  "layout": "awsui_layout_hyvsj_159il_322",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_159il_404",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_159il_431",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_159il_434",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_159il_438",
  "has-split-panel": "awsui_has-split-panel_hyvsj_159il_452",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_159il_452",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_159il_464",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_159il_467",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_159il_482",
  "container": "awsui_container_hyvsj_159il_490",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_159il_507",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_159il_512",
  "is-tools-open": "awsui_is-tools-open_hyvsj_159il_515",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_159il_515",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_159il_515",
  "content-type-default": "awsui_content-type-default_hyvsj_159il_535",
  "content-type-form": "awsui_content-type-form_hyvsj_159il_535",
  "unfocusable": "awsui_unfocusable_hyvsj_159il_576",
  "navigation-container": "awsui_navigation-container_hyvsj_159il_584",
  "show-navigation": "awsui_show-navigation_hyvsj_159il_608",
  "animating": "awsui_animating_hyvsj_159il_630",
  "showButtons": "awsui_showButtons_hyvsj_159il_1",
  "navigation": "awsui_navigation_hyvsj_159il_584",
  "openNavigation": "awsui_openNavigation_hyvsj_159il_1",
  "animated-content": "awsui_animated-content_hyvsj_159il_690",
  "hide-navigation": "awsui_hide-navigation_hyvsj_159il_699",
  "notifications": "awsui_notifications_hyvsj_159il_216",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_159il_766",
  "position-bottom": "awsui_position-bottom_hyvsj_159il_801",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_159il_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_159il_830",
  "position-side": "awsui_position-side_hyvsj_159il_857",
  "openSplitPanelSide": "awsui_openSplitPanelSide_hyvsj_159il_1",
  "tools-container": "awsui_tools-container_hyvsj_159il_894",
  "tools": "awsui_tools_hyvsj_159il_894",
  "openTools": "awsui_openTools_hyvsj_159il_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_159il_977",
  "hide-tools": "awsui_hide-tools_hyvsj_159il_987",
  "show-tools": "awsui_show-tools_hyvsj_159il_999",
  "has-tools-form": "awsui_has-tools-form_hyvsj_159il_977",
  "trigger": "awsui_trigger_hyvsj_159il_1056",
  "selected": "awsui_selected_hyvsj_159il_1094"
};
  